
import DirectboxSend from "../../../assets/duotone/DirectboxSend.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function DirectboxSendIcon({ className, dataTestid = "DirectboxSendIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <DirectboxSend data-testid={dataTestid} className={classes} {...rest} />
  );
}
